import * as React from 'react'

import { ErrorAlert, IconNotification, Space, TextLoader } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type SlackUser } from '@webapp/platform/integrations/entities/SlackUser'
import { ActiveUsersWithSlackTableView } from '@webapp/platform/integrations/features/list-active-users-with-slack/views/ActiveUsersWithSlackTableView'
import messages from './messages'
import { useActiveUsersWithSlackListPresenter } from './useActiveUsersWithSlackListPresenter'

export interface IActiveUsersWithSlackListPresenterProps {
  slackUserCache: Map<string, SlackUser>
  onUserLinkChange?: (userId: number, slackUser: SlackUser | null) => void
}

export const ActiveUsersWithSlackListPresenter = ({
  slackUserCache,
  onUserLinkChange,
}: IActiveUsersWithSlackListPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    data: { users, pagination, slackUserCache: cachedSlackUsers },
    states: {
      isLoading,
      isFetching,
      isError,
      page,
      pageSize,
      searchInputValue,
    },
    methods: {
      handlePageChange,
      handlePageSizeChange,
      handleSearchChange,
      handleSearchSubmit,
      handleUserLinkChange,
    },
  } = useActiveUsersWithSlackListPresenter({
    slackUserCache,
    onUserLinkChange,
  })

  if (isLoading) {
    return (
      <Space>
        <TextLoader width={400} />
        <TextLoader width={400} />
        <TextLoader width={400} />
      </Space>
    )
  }

  if (isError) {
    return (
      <ErrorAlert icon={<IconNotification />}>
        {intl.formatMessage(messages.errorMessage)}
      </ErrorAlert>
    )
  }

  return (
    <ActiveUsersWithSlackTableView
      users={users}
      pagination={pagination}
      isLoading={isFetching}
      page={page}
      pageSize={pageSize}
      searchInputValue={searchInputValue}
      onPageChange={handlePageChange}
      onPageSizeChange={handlePageSizeChange}
      onSearchChange={handleSearchChange}
      onSearchSubmit={handleSearchSubmit}
      slackUserCache={cachedSlackUsers}
      onUserLinkChange={handleUserLinkChange}
    />
  )
}
